<template>
  <div id="projects-detail">
    <div class="row">
      <div class="col-md-12">
        <ckeditor4 v-model="description" :config="editorConfig"></ckeditor4>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import helpers from '../helpers/helpers';
import SkillupEditorConfig from '../mixins/SkillupEditorConfig';

export default {
  mixins: [SkillupEditorConfig],
  props: ['projectId', 'descriptionType', 'initialDescription'],
  data() {
    return {};
  },
  computed: {
    description: {
      get() {
        return _.get(this.$store, ['state', 'onairDescriptionEditor', 'onairDescriptions', this.descriptionType], null);
      },
      set(value) {
        this.commitUpdateOnairDescriptionDebounced(value);
        EventBus.$emit('setIsSavedProject', false);
      },
    },
  },
  created() {
    this.initProjectEditor();
  },
  methods: {
    initProjectEditor() {
      this.$store.commit('createOnairDescription', {
        descriptionType: this.descriptionType,
        description: this.initialDescription,
      });
    },
    commitUpdateOnairDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateOnairDescription', {
        descriptionType: this.descriptionType,
        description: helpers.replaceSmartQuotes(value),
      });
    }, 100),
  },
};
</script>
